module.exports = __webpack_public_path__ + "img/cover_pressalit_1.4930db1b.jpg";